import { updateBadge } from './badging.js';
import { ALERTS_CHANGED_EVENT, OPEN_ALERTS_EVENT } from './fleet-map/events.js';

// A tap that asked for the alerts tab and that nothing has acted on yet.
// main.jsx adds the message listener as the page starts, but FleetMapLayout
// mounts only after the capabilities fetch and its own lazy chunk (App.jsx),
// so a tap relayed to a window that is still loading finds no listener for
// the window event. FleetMapLayout takes the request when it mounts, and its
// live listener takes it too, so each tap is acted on once. Memory only: a
// reload starts with none, so a stale tap can never come back.
let openAlertsPending = false;

/** True while a tap waits for the alerts tab. Reading does not take it, so
 *  a render (which React may run twice) can look without side effects. */
export function hasPendingOpenAlerts() {
  return openAlertsPending;
}

/** Takes the waiting tap: true once, then false until the next one. */
export function consumePendingOpenAlerts() {
  const pending = openAlertsPending;
  openAlertsPending = false;
  return pending;
}

// Push arrivals relay their badge_count via postMessage (see sw.js's 'push'
// handler) so the OS badge updates at once rather than waiting on
// FleetMapLayout's 30s poll: same resolved count, two delivery paths.
export function handleServiceWorkerMessage(event) {
  // A tap on a mandatory page or a self-test notification, relayed to the
  // app window sw.js focused (its 'notificationclick' handler).
  // FleetMapLayout shows the alerts tab. Recorded before the event, so a
  // listener that is there takes the request and leaves none behind.
  if (event.data?.type === 'OVR_OPEN_ALERTS') {
    openAlertsPending = true;
    window.dispatchEvent(new Event(OPEN_ALERTS_EVENT));
    return;
  }
  if (event.data?.type !== 'OVR_PUSH_ALERT') return;
  // A mandatory page carries no badge_count: the cloud worker sends it to
  // each recipient, not through the subscriber path that computes one. So
  // only a push that has one updates the OS badge here.
  if (typeof event.data.badge_count === 'number') updateBadge(event.data.badge_count);
  // Nudge the in-app count for every push, mandatory pages included. The OS
  // badge and the tab-bar badge are two renderings of the same number, so a
  // push arriving while the app is open must not leave them disagreeing
  // until FleetMapLayout's 30s poll catches up.
  window.dispatchEvent(new Event(ALERTS_CHANGED_EVENT));
}
